import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroService } from 'src/app/shared/services/services';
import * as _ from 'underscore';

@Component({
  selector: 'app-modal-importar-parametros',
  templateUrl: './modal-importar-parametros.component.html',
  styleUrls: ['./modal-importar-parametros.component.css']
})
export class ModalImportarParametrosComponent implements OnInit {

  @ViewChild('importarParametrosModal') private importarParametrosModal;

  //Catálogo de parámetros documentados que viene de RecaudoManager
  catalogo: Array<any> = [];
  cargando = false;
  filtro = { buscar: "" };
  oprimioBotonImportar = false;
  haySeleccion = false;

  modalRef: NgbModalRef;

  constructor(
    private _modalService: NgbModal,
    private toastr: ToastrService,
    public changeDetector: ChangeDetectorRef,
    private config: NgbModalConfig,
    private _sParametro: ParametroService
  ) { }

  ngOnInit() {
  }

  /**
   * Abre la modal y carga el catálogo de parámetros.
   * Los parámetros que el colegio ya tiene se muestran marcados como existentes y no se pueden seleccionar.
   * @param nombresExistentes Nombres de los parámetros que el colegio ya tiene en la lista
   */
  public abrirImportar(nombresExistentes: Array<string>): NgbModalRef {

    this.catalogo = [];
    this.filtro = { buscar: "" };
    this.oprimioBotonImportar = false;
    this.haySeleccion = false;

    this.config.backdrop = "static";
    this.config.keyboard = false;
    this.modalRef = this._modalService.open(this.importarParametrosModal, { size: "lg" });

    this.cargarCatalogo(nombresExistentes || []);

    return this.modalRef;
  }

  /**
   * Consulta el catálogo y marca cuáles parámetros ya existen en el colegio
   * @param nombresExistentes Nombres de los parámetros que el colegio ya tiene en la lista
   */
  private cargarCatalogo(nombresExistentes: Array<string>) {

    this.cargando = true;

    //Compara sin distinguir mayúsculas para no ofrecer duplicados por diferencia de casing
    let existentes = _.map(nombresExistentes, (n: string) => (n || "").toLowerCase());

    this._sParametro.getCatalogo().subscribe((data) => {

      this.catalogo = _.map(data, (p: any) => {
        p.seleccionado = false;
        p.yaExiste = existentes.indexOf((p.Nombre || "").toLowerCase()) !== -1;
        return p;
      });

      this.cargando = false;
      this.changeDetector.detectChanges();

    }, (error) => {
      this.cargando = false;
      this.toastr.error("No se pudo consultar el catálogo de parámetros", "Error");
      console.log("Error", error);
    });
  }

  /**
   * Valida que el usuario haya seleccionado por lo menos un parámetro
   */
  validarFormulario() {
    this.haySeleccion = _.find(this.catalogo, (p: any) => p.seleccionado === true) ? true : false;
    return !this.haySeleccion;
  }

  /**
   * Cierra la modal retornando los parámetros seleccionados
   */
  private importar() {

    this.oprimioBotonImportar = true;

    if (this.validarFormulario())
      return;

    this.modalRef.close(_.filter(this.catalogo, (p: any) => p.seleccionado === true));
  }

  /**
   * Cierra la modal
   */
  private cerrarModal() {
    this.modalRef.close();
  }
}
